export default "__VITE_ASSET__pgT3mDQe__"